import { NetSuiteExpenseLineExtendedExpenseReport } from '../../../data/types';

export const getMaxRefLineNumber = (lines: NetSuiteExpenseLineExtendedExpenseReport[]) => {
    return lines.reduce((max, line) => (!line.refLineNumber || max > line.refLineNumber ? max : line.refLineNumber), 1);
};

export const getAttachmentNameWithPostfix = (attachmentName: string, refLineNumber: number) => {
    const lastDotIndex = attachmentName.lastIndexOf('.');
    const lastUnderscoreIndex = attachmentName.lastIndexOf('_');
    const fileNameWithoutExtension = lastDotIndex === -1 ? attachmentName : attachmentName.slice(0, lastDotIndex);
    const baseName =
        lastUnderscoreIndex === -1 || !Number(fileNameWithoutExtension.slice(lastUnderscoreIndex + 1))
            ? fileNameWithoutExtension
            : fileNameWithoutExtension.slice(0, lastUnderscoreIndex);

    if (lastDotIndex === -1) {
        return `${baseName}_${refLineNumber}`;
    }

    return `${baseName}_${refLineNumber}.${attachmentName.slice(lastDotIndex + 1)}`;
};
